import './styles/index.css';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {initAnalytics} from './lib/analytics';
import {initPostHog} from './lib/posthog';

initAnalytics();
initPostHog();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
